import "./sprinkles.css.ts.vanilla.js";
import "./screen-reader-only.css.ts.vanilla.js";
var y = "gwdgwo1 _1y2v1nf65 _1y2v1nf6j _1y2v1nf6x _1y2v1nf7b _1y2v1nf5e _1y2v1nf9o _1y2v1nf9g";
export { y as screenReaderOnly };
